import React from 'react';
import { Icon } from '@kontentino/ui';
import { faMusic } from '@fortawesome/pro-regular-svg-icons/faMusic';
import { useTranslation } from 'react-i18next';

interface InstagramAudioTrackListEmptyProps {
  searchQuery: string;
}

const InstagramAudioTrackListEmpty = ({
  searchQuery,
}: InstagramAudioTrackListEmptyProps) => {
  const { t } = useTranslation();

  const message = searchQuery
    ? t('instagramAudio.noResults', { query: searchQuery })
    : t('instagramAudio.noTracksAvailable');

  return (
    <div
      className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-p-8 tw-text-center"
      data-cy="instagram-audio_empty-state"
    >
      <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-20">
        <Icon icon={faMusic} className="tw-text-primary-100" size="lg" />
      </div>
      <p className="tw-text-sm tw-font-medium tw-text-grayscale-180">
        {message}
      </p>
    </div>
  );
};

export default InstagramAudioTrackListEmpty;
